import {h, Fragment} from "preact"
export default function Loader() {
    return (
        <div
            class="ns-loader-wrapper ns-d-flex ns-justify-content-center ns-align-items-center"
            style="position: absolute; z-index: 1;"
        >
            <div class="ns-loader"></div>
        </div>
    )
}
